import React from 'react';
import loadable from '@loadable/component';

const Modal = loadable(() => import(/* webpackChunkName: "extra" */ './modal'));

const ModalLoader = props => <Modal {...props} />;

export default ModalLoader;
